import styled from "styled-components/macro";

import background from "Payments/CreditCardAssets/CardBackgrounds/amex_bg.jpg";
import border from "Payments/CreditCardAssets/CardBackgrounds/amex_border.png";
import face from "Payments/CreditCardAssets/LargeCardLogos/amex_man.png";
import logo from "Payments/CreditCardAssets/LargeCardLogos/amex_words.png";
import { motion } from "framer-motion";

import { Shine, iPhone, iPhoneMini } from "../styles";

export default function AmericanExpress({ isAlreadyExisting }) {
  return (
    <>
      <Background
        initial={isAlreadyExisting ? {} : { opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.2 } }}
        exit={{ opacity: 0 }}
      />
      <BackgroundPattern
        initial={isAlreadyExisting ? {} : { opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.1 } }}
        exit={{ opacity: 0 }}
      />
      <Border
        initial={isAlreadyExisting ? {} : { scale: 1.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 1, transition: { delay: 0.2 } }}
        exit={{ scale: 1.2, opacity: 0, transition: { type: "tween" } }}
      />
      <Face
        initial={isAlreadyExisting ? {} : { scale: 0.8, opacity: 0 }}
        animate={{ y: 0, scale: 1, opacity: 1, transition: { delay: 0.2 } }}
        exit={{ scale: 0.8, opacity: 0, transition: { type: "tween" } }}
      />
      <Shine />
      <Logo
        src={logo}
        initial={isAlreadyExisting ? {} : { y: 20, scale: 0.8, opacity: 0 }}
        animate={{ y: 0, scale: 1, opacity: 1, transition: { delay: 0.4 } }}
        exit={{ y: 20, scale: 0.8, opacity: 0, transition: { type: "tween" } }}
      />
    </>
  );
}

const Background = styled(motion.div)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f5fffe;
`;

const Logo = styled(motion.div)`
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  height: 14px;
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;

  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    top: auto;
    bottom: ${iPhoneMini.logoBottom};
    margin-bottom: -12px;
  }
`;

const Border = styled(motion.div)`
  background-image: url(${border});
  background-size: contain;
  position: absolute;
  background-repeat: no-repeat;
  background-position: center center;
  top: 10px;
  bottom: 10px;
  left: 10px;
  right: 10px;
  &::after {
    content: "";
    position: absolute;
    border-bottom: 1px solid #191919;
    border-top: 1px solid #191919;
    left: 14px;
    right: 14px;
    bottom: 0.5px;
    height: 1px;
    background: #e7e6e4;
  }
  @media screen and (max-width: ${iPhone.cssWidth}) {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-size: 101% 101%;
    &::after {
      display: none;
    }
  }
`;
const BackgroundPattern = styled(motion.div)`
  background-image: url(${background});
  background-size: cover;
  position: absolute;
  background-repeat: no-repeat;
  background-position: center center;
  top: 13px;
  bottom: 13px;
  left: 13px;
  right: 13px;
  border-radius: 4px;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
const Face = styled(motion.div)`
  aspect-ratio: 122 / 153;
  width: 108px;
  @supports not (aspect-ratio: auto) {
    height: 135px;
  }
  margin-left: -54px;
  background-image: url(${face});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  left: 50%;
  bottom: 40px;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    bottom: 10%;
    @supports not (aspect-ratio: auto) {
      display: none;
    }
  }
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    width: 86px;
    margin-left: -43px;
    bottom: 16%;
  }
`;
